import React, { PureComponent } from "react"

/* Constants */
import { utils, env } from "../../constants"


/* Component Surrender */
class Surrender extends PureComponent {

    render = () => {

        const { onClick } = this.props

        return (
            <div onClick={() => onClick()} className="game-button surrender-button">
                <img src={`${env.endpoint}/images/buttons/surrender.png`} alt="double" />
                <p>{utils.translate("SURRENDER")}</p>
            </div>
        )
    }

}

export default Surrender